// extracted by mini-css-extract-plugin
module.exports = {"root":"StateCard_root__kD3TE","image":"StateCard_image__1GHvi","imageOverlay":"StateCard_imageOverlay__3HVZy","title":"StateCard_title__2hxi_"};